import React from 'react';
import classNames from 'classnames';
import PremiumCamIconMedium from 'components/Icons/PremiumCamIconMedium';
import SurfConditions from 'components/SurfConditions';
import checkConditionValue from 'utils/checkConditionValue';
import { SpotTravel } from 'types/spot';

import styles from './SpotListCTAThumbnail.module.scss';

interface SpotListCTAThumbnailProps {
  spot: SpotTravel;
  isTooltip?: boolean;
}

const getThumbnailClassName = (isTooltip: boolean) =>
  classNames({
    [styles.spotListCtaThumbnail]: true,
    'quiver-spot-list-cta-thumbnail': true,
    [styles['spotListCtaThumbnail--tooltip']]: isTooltip,
    'quiver-spot-list-cta-thumbnail--tooltip': isTooltip,
  });

const SpotListCTAThumbnail: React.FC<SpotListCTAThumbnailProps> = ({ spot, isTooltip = false }) => (
  <div className={getThumbnailClassName(isTooltip)}>
    <div className="quiver-spot-list-cta-thumbnail__indicator">
      <PremiumCamIconMedium />
    </div>
    <div className="quiver-spot-list-cta-thumbnail__spot-details">
      <h3 className="quiver-spot-list-cta-thumbnail__spot-details__name">{spot.name}</h3>
      <SurfConditions conditions={checkConditionValue(spot.conditions.value)} />
    </div>
  </div>
);

export default SpotListCTAThumbnail;
